<template>
  <div class="app-main-content">
    <div v-if="showGrid" class="main-content" style="flex-grow: 1; display: flex;flex-direction: column;">
      <!--货运险查询条件-->
      <search-item
        v-if="insuranceType === 1"
        config-module="1101"
        :show-more-scheme="true"
        :show-simple="false"
        :expand-adv="true"
        :search-item-code="$t('Insurance.PolicyManagement')"
        :custom-sim-query-placeholder="$t('Insurance.QuickSearchPolicyNumber')"
        @advSearchItemCallBack="fetchData"
      >
        <template slot="operations">
          <el-button type="danger" @click="deletePolicy">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </template>
        <template v-slot:searchAreaHeader />
      </search-item>
      <!--责任险查询条件-->
      <search-item
        v-if="insuranceType === 2"
        config-module="1102"
        :show-more-scheme="true"
        :show-simple="false"
        :expand-adv="true"
        :search-item-code="$t('Insurance.PolicyManagement')"
        :custom-sim-query-placeholder="$t('Insurance.QuickSearchPolicyNumber')"
        @advSearchItemCallBack="fetchData"
      >
        <template slot="operations">
          <el-button type="success" @click="addInquiry('')">{{ $t('Insurance.AddInquiryQuestionnaire') }}</el-button>
          <el-button type="primary" @click="editInquiry">{{ $t('Insurance.EditOrViewQuestionnaire') }}</el-button>
        </template>
        <template v-slot:searchAreaHeader />
      </search-item>
      <div class="section grid-wrapper" style="flex-grow: 1">
        <cargo-ag-grid
          v-if="insuranceType === 1"
          config-module="110101"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="insureColumnDefs"
          :row-data="rowData"
          height="100%"
          @gridReady="params=>gridApi=params.api"
        />
        <cargo-ag-grid
          v-if="insuranceType === 2"
          config-module="110201"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="inquiryColumnDefs"
          :row-data="rowData"
          height="100%"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <div class="pagination-wrapper">
        <div style="display: flex;justify-content: flex-end;">
          <currency-total-group :data-provider="premiumList" />
        </div>
        <cargo-pagination
          v-if="insuranceType === 1"
          config-module="110102"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
        <cargo-pagination
          v-if="insuranceType === 2"
          config-module="110202"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
    <div v-if="!showGrid" class="main-content" style="background: white;height: 800px">
      <div style="text-align: right">
        <i class="el-icon-close" style="font-size: 20px;margin: 10px" @click="showGridPage(null)" />
      </div>
      <h1 style="text-align: center;margin-top: 10%;margin-bottom: 4%"><i class="el-icon-success" style="color: #13ce66;font-size: 50px;margin-right: 20px" />提交成功，我们会在24小时之内由专人与您取得联系</h1>
      <hr style="margin: 0 40px">
      <h1 style="text-align: center">您还可以</h1>
      <br>
      <h1 style="text-align: center">{{ '电话联系：' + getInsureAgentContact() }}</h1>
    </div>
    <!--询价弹出框-->
    <inquiry ref="inquiry" :visible="inquiry.visible" @close="closeInquiry" @showGridPage="showGridPage" />

    <!-- 预览文件弹窗 -->
    <cargo-dialog
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :can-maximize="true"
      custom-class="preview-dialog"
      @close="closePreviewDialog"
    >
      <div>
        <!--        <el-scrollbar>-->
        <!--          <pdf v-for="i in previewFileData.numPages" :key="i" :src="previewFileData.pdfSrc" :page="i" />-->
        <!--        </el-scrollbar>-->
        <p style="text-align: center">
          <span class="turn" :class="{grey: previewFileData.currentPage==1}" @click="changePdfPage(0)">{{ $t('SeaExport.Pre') }}</span>
          {{ previewFileData.currentPage }} / {{ previewFileData.numPages }}
          <span class="turn" :class="{grey: previewFileData.currentPage==previewFileData.numPages}" @click="changePdfPage(1)">{{ $t('SeaExport.Next') }}</span>
        </p>
        <pdf
          :src="previewFileData.pdfSrc"
          :page="previewFileData.currentPage"
          @num-pages="previewFileData.numPages=$event"
          @page-loaded="previewFileData.currentPage=$event"
          @loaded="loadPdfHandler"
        />
      </div>
    </cargo-dialog>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getGridSelected } from '@/utils/agGrid'
import * as NumberUtils from '@/utils/NumberUtils'
import {
  getLiabilityUnSubmit,
  insureAdvacedQuery,
  recordDownPolicy,
  removeInsureRecord
} from '@/api/external/insureInfo'
import OperationRender from '@/components/OperationRender'
import Inquiry from '@/views/cargo/v0/Insurance/components/inquiry'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import pdf from 'vue-pdf'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import * as InsuranceConstants from '@/class/cargo/model/parameters/InsuranceConstants'
import { formatNumberToThousands } from '@/utils'
import CurrencyTotalGroup from '@/views/cargo/v0/Insurance/components/CurrencyTotalGroup'
import { InsureInfo } from '@/class/model/booking/InsureInfo'
import URL from '@/api/urlTranslator'

export default {
  name: 'PolicyGrid',
  components: { CurrencyTotalGroup, searchItem, Inquiry, pdf, CargoDialog },
  props: {
    insuranceType: { type: Number, required: true }
  },
  data() {
    return {
      loading: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: false
      },
      gridParams: {},
      filterJson: {},
      gridApi: null,
      rowData: [],
      searchConditions: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        snapshotConditions: [] // 存储高级查询条件（点击查询时赋值）
      },
      premiumList: [],
      inquiry: {
        visible: false
      },
      storageURL: '',
      showGrid: true,
      insuranceAgent: '',
      // 预览文件参数
      previewFileData: {
        visible: false,
        pdfUrl: '',
        pdfSrc: '',
        numPages: 0,
        currentPage: 0
      },
      isHM: false
    }
  },
  computed: {
    insureColumnDefs() {
      const column = [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Insurance.TheInsured'), field: 'insuredName', colId: 'insuredName' },
        { headerName: this.$t('Insurance.InsuranceAgent'), field: 'insuranceAgent', colId: 'insuranceAgent',
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, InsuranceConstants.INSURANCE_AGENT)
          }
        },
        { headerName: this.$t('Insurance.InsuranceCompany'), field: 'insuranceCompany', colId: 'insuranceCompany',
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, InsuranceConstants.INSURANCE_COMPANY)
          }
        },
        { headerName: this.$t('Insurance.InsureNo'), field: 'insureNo', colId: 'insureNo' },
        { headerName: this.$t('Insurance.PolicyNo'), field: 'policyNo', colId: 'policyNo' },
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', colId: 'jobNo' },
        { headerName: this.$t('Insurance.BillOfLoadingNo'), field: 'billno', colId: 'billno' },
        { headerName: this.$t('Insurance.PlaceOfOrigin'), field: 'portLoading', colId: 'portLoading', width: 160 },
        { headerName: this.$t('Insurance.Destination'), field: 'destination', colId: 'destination', width: 160 },
        {
          headerName: this.$t('Insurance.InsureOrderUser'),
          field: '',
          colId: '',
          width: 200,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('Insurance.EditViewInsuranceForm'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.editInsuranceForm(params)
                },
                visible: (params) => this.$checkPermission(['role_cargoInsurance_EditPolicies'])
              }, {
                title: this.$t('CargoMsg.Cargo_Delete'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;color: red',
                onClick: (params) => {
                  this.deleteOnePolicy(params)
                },
                visible: (params) => this.$checkPermission(['role_cargoInsurance_DeletePolicies'])
              },
              {
                title: this.$t('CargoMsg.Cargo_ClaimSettlement'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;color: red',
                onClick: (params) => {
                  ColumnUtils.jumpToInsurance(params)
                },
                visible: (params) => ColumnUtils.isClaimVisible(params) && !this.isHM
              }
            ]
          }
        },
        {
          headerName: this.$t('Insurance.PolicyUser'),
          field: 'insuranceFileId',
          colId: 'insuranceFileId',
          width: 200,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('CargoMsg.Cargo_Preview'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.viewPolicy(params.insuranceFileId)
                },
                visible: (params) => params.insuranceFileId && !this.isHM
              }, {
                title: this.$t('Insurance.PolicyDownload'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.downloadPolicyFile(params)
                },
                visible: (params) => params.insuranceFileId && !this.isHM
              }
            ]
          }
        },
        { headerName: this.$t('Insurance.InvoiceNo'), field: 'invoiceNo', colId: 'invoiceNo' },
        { headerName: this.$t('Insurance.Waybillno'), field: 'waybillno', colId: 'waybillno' },
        { headerName: this.$t('Insurance.Premium'), field: 'premium', colId: 'premium',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        { headerName: this.$t('Insurance.PremiumCurrency'), field: 'premiumCurrency', colId: 'premiumCurrency' },
        { headerName: this.$t('Insurance.Rate'), field: 'rate', colId: 'rate' },
        { headerName: this.$t('Insurance.SubmissionTime'), field: 'submitDate', colId: 'submitDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.DeliveryTime'), field: 'issuingTime', colId: 'issuingTime',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.DeliveryStatus'), field: 'issuingState', colId: 'issuingState',
          cellRenderer: (params) => {
            // return ColumnUtils.issuingStatusLabelFunc(params.value)
            return ColumnUtils.showTypeLabelFunc(params.value, InsuranceConstants.ISSUING_STATUS)
          }
        },
        { headerName: this.$t('Insurance.DateOfShipment'), field: 'departureStartDate', colId: 'departureStartDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.InvoiceAmount'), field: 'invoiceAmount', colId: 'invoiceAmount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        { headerName: this.$t('Insurance.InvoiceCurrency'), field: 'invoiceCurrency', colId: 'invoiceCurrency' },
        // { headerName: this.$t('Insurance.InsuranceAmount'), field: 'insuranceAmount', colId: 'insuranceAmount',
        //   cellRenderer: (params) => {
        //     return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
        //   }
        // },
        // { headerName: this.$t('Insurance.InsuranceCurrency'), field: 'insuranceCurrency', colId: 'insuranceCurrency' },
        { headerName: this.$t('Insurance.StartDate'), field: 'insuranceDate', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.EndDate'), field: 'finInsuranceDate', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.PolicySyncStatus'), field: 'policySyncStatus', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.offsetStateLabFun(params.value)
          }
        },
        { headerName: this.$t('Insurance.PremiumSyncStatus'), field: 'premiumSyncStatus', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.offsetStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Creator'), field: 'createdBy', colId: 'createdBy',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'dateCreated',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.ModifiedBy'), field: 'modifyUser', colId: 'modifyUser',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ModificationTime'), field: 'dateModified', colId: 'dateModified', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ]
      // 判断是否有账单权限
      if (this.$checkPermission(['role_cargoInsurance_billingManagement'])) {
        column.push({
          headerName: this.$t('Insurance.ReconciliationUser'),
          field: '',
          colId: '',
          width: 200,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('Insurance.BillQuery'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.billQuery(params)
                },
                visible: (params) => !this.isHM
              }, {
                title: this.$t('Insurance.InvoiceDownload'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.downloadFile(params.invoiceFileId)
                },
                visible: (params) => params.invoiceFileId && !this.isHM
              }
            ]
          }
        })
      }
      return column
    },
    inquiryColumnDefs() {
      const inquiryColumn = [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Insurance.TheInsured'), field: 'insuredName', colId: 'insuredName' },
        { headerName: this.$t('Insurance.InsuranceAgent'), field: 'insuranceAgent', colId: 'insuranceAgent',
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, InsuranceConstants.INSURANCE_AGENT)
          }
        },
        {
          headerName: this.$t('Insurance.QuestionnaireStatus'), field: 'questionnaireStatus', colId: 'questionnaireStatus',
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, InsuranceConstants.QUESTIONNAIRE_STATUS)
          }
        },
        { headerName: this.$t('Insurance.InsuranceCompany'), field: 'insuranceCompany', colId: 'insuranceCompany',
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, InsuranceConstants.INSURANCE_COMPANY)
          }
        },
        { headerName: this.$t('Insurance.InsureNo'), field: 'insureNo', colId: 'insureNo' },
        { headerName: this.$t('Insurance.PolicyNo'), field: 'policyNo', colId: 'policyNo' },
        { headerName: this.$t('Insurance.DeliveryStatus'), field: 'issuingState', colId: 'issuingState',
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, InsuranceConstants.ISSUING_LIABILITY_STATUS)
          }
        },
        // { headerName: this.$t('Insurance.InsuranceAmount'), field: 'insuranceAmount', colId: 'insuranceAmount' },
        // { headerName: this.$t('Insurance.InsuranceCurrency'), field: 'insuranceCurrency', colId: 'insuranceCurrency' },
        { headerName: this.$t('Insurance.Premium'), field: 'premium', colId: 'premium' },
        { headerName: this.$t('Insurance.PremiumCurrency'), field: 'premiumCurrency', colId: 'premiumCurrency' },
        { headerName: this.$t('Insurance.Rate'), field: 'rate', colId: 'rate' },
        { headerName: this.$t('Insurance.StartDate'), field: 'insuranceDate', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.EndDate'), field: 'finInsuranceDate', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Insurance.PolicyUser'),
          field: 'insuranceFileId',
          colId: 'insuranceFileId',
          width: 200,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('CargoMsg.Cargo_Preview'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.viewPolicy(params.insuranceFileId)
                },
                visible: (params) => params.insuranceFileId
              }, {
                title: this.$t('Insurance.PolicyDownload'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.downloadPolicyFile(params)
                },
                visible: (params) => params.insuranceFileId
              }
            ]
          }
        },
        { headerName: this.$t('Insurance.ServiceProviderReply2'), field: 'supplierResponse', colId: 'supplierResponse',
          cellRenderer: (params) => {
            let reply = ''
            if (params.value) {
              const replyList = JSON.parse(params.value)
              for (const item of replyList) {
                reply = reply + ColumnUtils.dateMinutesLabelFunc(item.replyTime) + '：' + item.content + '\n'
              }
            }
            return reply
          },
          tooltipValueGetter: (params) => {
            let reply = ''
            if (params.value) {
              const replyList = JSON.parse(params.value)
              for (const item of replyList) {
                reply = reply + ColumnUtils.dateMinutesLabelFunc(item.replyTime) + '：' + item.content + '\n'
              }
            }
            return reply
          }
        },
        { headerName: this.$t('Insurance.SubmissionTime'), field: 'submitDate', colId: 'submitDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.ContactWay'), field: 'contactInformation', colId: 'contactInformation',
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.data.insuranceAgent, InsuranceConstants.CONCAT_AGENTS)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Contact'), field: 'contactUser', colId: 'contactUser',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ContactNumber'), field: 'contactTel', colId: 'contactTel' },
        { headerName: this.$t('Partners.emailAddress2'), field: 'contactAddress', colId: 'contactAddress' },
        { headerName: this.$t('Insurance.RegisteredName'), field: 'registeredIdx', colId: 'registeredIdx',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Insurance.RegisteredAddress'), field: 'registeredAddress', colId: 'registeredAddress' },
        { headerName: this.$t('Insurance.BusinessName'), field: 'businessName', colId: 'businessName' },
        { headerName: this.$t('Insurance.BusinessAddress'), field: 'businessAddress', colId: 'businessAddress' },
        {
          headerName: this.$t('CargoMsg.Cargo_Creator'), field: 'createdBy', colId: 'createdBy',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'dateCreated',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ModificationTime'), field: 'dateModified', colId: 'dateModified', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BranchCompany'), field: 'branchId', colId: 'branchId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Insurance.DeliveryTime'), field: 'issuingTime', colId: 'issuingTime',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remarks', colId: 'remarks' }
      ]
      return inquiryColumn
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
    this.isHM = cache.config.get('ToExoSystem') === 'HONGMING'
    this.user = cache.user
    this.fetchDataByPage()
  },
  methods: {
    fetchData(conditions) {
      this.searchConditions.pageNum = 1
      this.toAdvQueryList(conditions)
    },
    fetchDataByPage() {
      setTimeout(() => {
        this.toAdvQueryList(this.searchConditions.snapshotConditions)
      }, 100)
    },
    toAdvQueryList(data) {
      this.filterJson = {}
      this.filterJson.conditions = []
      if (typeof data !== 'undefined') {
        this.searchConditions.snapshotConditions = data
        this.filterJson.conditions = data
      }
      this.filterJson.pageNum = this.searchConditions.pageNum
      this.filterJson.pageSize = this.searchConditions.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.insuranceType = this.insuranceType
      this.loading = getLoading4Cxt(this)
      let curSelected = null
      if (this.gridApi && this.gridApi.getSelectedRows()) {
        curSelected = this.gridApi.getSelectedRows().map(item => item.uuid)
      }
      insureAdvacedQuery(this.filterJson).then(res => {
        this.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
        this.refreshPremium()
      }).finally(() => {
        this.gridApi.clearFocusedCell()
        if (curSelected && curSelected.length) {
          this.$nextTick(() => {
            this.gridApi.forEachNode(node => {
              if (node.data && node.data.uuid && curSelected.find((id) => id === node.data.uuid)) {
                node.setSelected(true)
              }
            })
          })
        }
        this.loading.close()
      })
    },
    // 删除保单
    deletePolicy() {
      if (!this.$checkPermission(['role_cargoInsurance_DeletePolicies']) && !this.$store.getters.isAdmin) {
        this.$message.warning(this.$t('Insurance.YouPermissionToDeletePolicy'))
        return
      }
      const selectedRows = this.gridApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Information.PleaseARecordForDeletion'))
        return
      }
      for (const item of selectedRows) {
        if (item.issuingState === InsuranceConstants.SUBMITTED.code || item.issuingState === InsuranceConstants.ISSUED_ORDER.code) {
          this.$message.warning(this.$t('Insurance.NotAllowDeleteSubmited'))
          return
        }
      }
      this.$confirm(this.$t('Insurance.DeletingThePolicyRecordContinue'), this.$t('Insurance.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const insureKeys = []
        for (const item of selectedRows) {
          insureKeys.push(item.uuid)
        }
        this.loading = getLoading4Cxt(this)
        removeInsureRecord({ insureKeys: insureKeys }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.fetchDataByPage()
        }).finally(() => this.loading.close())
      })
    },
    // 删除单个保单
    deleteOnePolicy(data) {
      if (!this.$checkPermission(['role_cargoInsurance_DeletePolicies']) && !this.$store.getters.isAdmin) {
        this.$message.warning(this.$t('Insurance.YouPermissionToDeletePolicy'))
        return
      }
      if (data.issuingState === InsuranceConstants.SUBMITTED.code || data.issuingState === InsuranceConstants.ISSUED_ORDER.code) {
        this.$message.warning(this.$t('Insurance.NotAllowDeleteSubmited'))
        return
      }
      this.$confirm(this.$t('Insurance.DeletingThePolicyRecordContinue'), this.$t('Insurance.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const insureKeys = []
        insureKeys.push(data.uuid)
        this.loading = getLoading4Cxt(this)
        removeInsureRecord({ insureKeys: insureKeys }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.fetchDataByPage()
        }).finally(() => this.loading.close())
      })
    },
    // 编辑/查看保单
    editInsuranceForm(data = null) {
      if (this.isHM) {
        window.open(data.insureLink)
        return
      }
      this.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.$t('Insurance.ToInsure') + data.billno, key: data.uuid },
        params: { insureForm: data }
      })
    },
    // 账单查询
    billQuery(data) {
      this.$emit('changeTab', 'bill', null, data.insuranceAgent)
    },
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.previewFileData.currentPage > 1) {
        this.previewFileData.currentPage--
        console.log(this.previewFileData.currentPage)
      }
      if (val === 1 && this.previewFileData.currentPage < this.previewFileData.numPages) {
        this.previewFileData.currentPage++
        console.log(this.previewFileData.currentPage)
      }
    },
    loadPdfHandler(e) {
      this.previewFileData.currentPage = 1 // 加载的时候先加载第一页
    },
    // 查看保单
    viewPolicy(value) {
      let { pdfSrc, numPages } = this
      let baseUrl = window.location.origin
      if (!baseUrl) {
        baseUrl = process.env.VUE_APP_BASE_API
      }
      const pdfUrl = `${baseUrl}/api/mdm-service/storage/findByFileId/${value}?sessionId=${this.$store.getters.token}`
      this.loading = getLoading4Cxt(this)
      pdfSrc = pdf.createLoadingTask(encodeURI(pdfUrl))
      pdfSrc.promise.then(pdf => {
        numPages = pdf.numPages
      }).catch((err) => {
        console.log(this.$t('Message.FailedToGetTemplate'), err)
      }).finally(() => this.loading.close())
      this.previewFileData.pdfSrc = pdfSrc
      this.previewFileData.numPages = numPages
      this.previewFileData.currentPage = 1
      this.previewFileData.visible = true
    },
    // 下载
    downloadFile(value) {
      window.open(`${URL.common.findByFileId}/${value}?sessionId=${this.user.sessionId}`)
    },
    // 下载
    downloadPolicyFile(data) {
      window.open(`${URL.common.findByFileId}/${data.insuranceFileId}?sessionId=${this.user.sessionId}`)
      recordDownPolicy({ afUuid: data.uuid })
    },
    // 合计保费币种
    refreshPremium() {
      const total = 0
      let rowData = []
      if (!this.gridOptions || !this.gridOptions.api) {
        return
      }
      const selections = getGridSelected(this.gridOptions)
      if (selections && selections.length > 0) {
        rowData = selections
      } else {
        rowData = this.rowData
      }
      // 计算逻辑
      const map = new Map()
      if (rowData && rowData.length > 0) {
        for (const item of this.rowData) {
          const currency = item.premiumCurrency // 币种
          if (item.premium === '' || item.premium === null || currency === '' || currency === null) {
            continue
          }
          const insuranceAmount = isNaN(item.premium) ? 0 : item.premium // 币种对应的总保费
          if (!map.has(currency)) {
            map.set(currency, 0)
          }
          let total = map.get(currency)
          total += parseFloat(insuranceAmount)
          map.set(currency, total)
        }
      }
      const list = []
      map.forEach(function(value, key) {
        list.push({ 'currency': key, 'amount': NumberUtils.roundHalfUp(value, 2) })
      })
      this.premiumList = list
    },
    // 新增询价问卷
    async addInquiry(agent) {
      this.inquiry.visible = true
      // this.$refs.inquiry.openInsure(agent)
      const office = this.$store.getters.currentOffice
      const userInfo = this.$store.getters.userInfo
      let form = new InsureInfo().fillDefaultValue().getData()
      let hasform = false
      await getLiabilityUnSubmit({ branchId: office.officeId, contactUser: userInfo.userId }).then(async res => {
        if (res.ok && res.data) {
          hasform = true
          form = res.data
        }
      })
      if (!hasform) {
        form.registeredIdx = office.officeId
        form.registeredName = office.chineseName
        form.registeredAddress = office.chineseAddress
        form.contactUser = userInfo.userId
        form.contactTel = userInfo.userPhone
        form.contactAddress = userInfo.email
      }
      form.insuranceAgent = 'htjj'
      if (agent) {
        form.insuranceAgent = agent
      }
      this.$refs.inquiry.onShow(form)
    },
    // 编辑询价问卷
    editInquiry() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Information.PleaseARecordForEditing'))
        return
      }
      this.inquiry.visible = true
      if (selectedRows[0] && selectedRows[0].uuid) {
        this.$refs.inquiry.onShow(selectedRows[0])
      }
    },
    // 关闭询价问卷
    closeInquiry() {
      this.inquiry.visible = false
      this.fetchDataByPage()
    },
    // 是否展示询价关闭页面
    showGridPage(agent = null) {
      if (agent) {
        this.showGrid = false
        this.insuranceAgent = agent
      } else {
        this.showGrid = true
        this.insuranceAgent = ''
      }
    },
    getInsureAgentContact() {
      return ColumnUtils.showTypeLabelFunc(this.insuranceAgent, InsuranceConstants.CONCAT_AGENTS)
    },
    closePreviewDialog() {
      this.previewFileData.pdfSrc = ''
      this.previewFileData.numPages = ''
      this.previewFileData.visible = false
    }
  }
}
</script>

<style lang="scss">
</style>

